import { useCallback, useEffect, useState, useRef } from 'react';
import { Button } from 'antd';
import { AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react';
import { DeleteOutlined } from '@ant-design/icons';
import { Pagination } from 'antd';
import './HandbookGrid.css';
import { useNavigate } from 'react-router-dom';
import Quiz3Review from '../quiz/pages/PDFReview/pdf-review';
import HandbookCompletionDescription from '../../components/handbook-completion-description/handbook-completion-description';
import LogoUpload from '../../components/LogoUpload'
import { Spin } from 'antd';
import axios from 'axios';
import client from '../../utils/contentfulClient';

export const HandbookGrid = () => {

  const [pageNumber, setPageNumber] = useState([1]);
  const [handbooks, setHandbooks] = useState([]);
  const downloadRef = useRef(null);
  const [renderQuizReview, setRenderQuizReview] = useState(false)
  const [loading, setLoading] = useState(false);
  const [popupText, setPopupText] = useState({});
  const navigate = useNavigate();

  const cleanLocalStorage = () => {
    localStorage.removeItem('quiz-step1-page1')
    localStorage.removeItem('quiz-step2-page1')
    localStorage.removeItem('reset')
    localStorage.removeItem('selected-workplace-hazard')
  }

  const fetchContentfulData = async () => {
    const [popup] = await Promise.all([
      client.getEntries({ content_type: 'popup', include: 10 }),
    ]);
    setPopupText(popup.items[0].fields.popupText)
  }

  const fetchContentful = useCallback(() => {
    fetchContentfulData();
  }, []);

  const data = {
    currentPageNumb: pageNumber,
    handbooks: []
  };

  const changedPageNumber = (num) => {
    setPageNumber(num);
  };

  const newHandbook = () => {
    cleanLocalStorage()
    window.location = '/safety-orientation-handbook/#page-1';

  };

  const goBack = () => { };

  const goNext = () => { };

  const downloadHandbook = (handbookO) => {
    localStorage.removeItem('reset');
    let basicDetailsTemp = {
      formValues: {}, outcome
        : ''
    };
    let additionalDetailsTemp = [];
    if (handbookO?.basicDetails) {
      basicDetailsTemp.formValues = handbookO.basicDetails;
    }
    if (handbookO?.additionalDetails) {
      additionalDetailsTemp = handbookO.additionalDetails;
    }
    window.localStorage.setItem('quiz-step1-page1', JSON.stringify(basicDetailsTemp));
    window.localStorage.setItem('quiz-step2-page1', JSON.stringify(additionalDetailsTemp));
    setRenderQuizReview(true)
    setLoading(true)
  };

  const handleDownload = () => {
    return new Promise((resolve, reject) => {
      if (downloadRef.current) {
        try {
          downloadRef.current();
          resolve('Download initiated successfully');
        } catch (error) {
          reject('Error initiating download: ' + error.message);
        }
      } else {
        reject('Download reference is not set');
      }
    });
  };

  const onDownloadComplete = () => {
    setRenderQuizReview(false)
    setLoading(false)
  }

  useEffect(() => {
    if (renderQuizReview)
      setTimeout(() => {
        handleDownload().then(() => {
          onDownloadComplete()
        }).catch((err) => {
          console.error('Download failed:', err);
        }).finally(() => {
          onDownloadComplete()
        })
      }, 5000)
  }, [renderQuizReview])


  const deleteHandbook = async (handbookO) => {
    try {
      const endpoint = `${process.env.REACT_APP_BASE_URL}/handbook/` + handbookO.id;
      const token = JSON.parse(localStorage.getItem('loginToken'));

      const response = await axios({
        method: 'DELETE',
        url: endpoint,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      })
      if (response?.data?.jsonBody) {
        const newHandbookList = handbooks.filter(item => item.id !== handbookO.id);
        setHandbooks(newHandbookList);
      }
    } catch (error) {
      console.error('Failed to delete the handbook', error);
    }
  };

  const editHandbook = (handbook) => {
    cleanLocalStorage()
    navigate(`/safety-orientation-handbook/quiz/${handbook?.id}`);
  };

  //DATE CONVERTER
  function formatDate(dateString) {
    const date = new Date(dateString);
    const options = { day: '2-digit', month: 'short', year: 'numeric' };
    return date.toLocaleDateString('en-GB', options);
  }

  //GET QUIZ SINGLE FIELD FORMVALUE
  function getInputValues(inputName, formValuesArr) {
    if (formValuesArr) {
      const inputObject = formValuesArr.find((item) => {
        const key = Object.keys(item)[0];
        return key === inputName;
      });

      return inputObject ? inputObject[Object.keys(inputObject)[0]] : {};
    }
  }

  const fetchHandbooks = async () => {
    try {
      const endpoint = `${process.env.REACT_APP_BASE_URL}/handbook/`;
      const token = JSON.parse(localStorage.getItem('loginToken'));

      const response = await axios({
        method: 'GET',
        url: endpoint,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      })
      if (response.data?.jsonBody?.handbooks) {
        setHandbooks(response.data?.jsonBody?.handbooks);
      }
    } catch (error) {
      console.error('Failed to get the handbooks', error);
    }
  }

  const handleLoginRedirect = () => {
    window.instance.loginRedirect(loginRequest).catch((error) => console.log(error));
  };

  useEffect(() => {
    fetchHandbooks();
    fetchContentful();
  }, []);

  return (
    <>
      <AuthenticatedTemplate>
        {loading ?
          <div style={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            zIndex: 1000
          }}>
            <Spin size="large" />
          </div> :
          <div className="handbook-container">
            <div className="handbook-grid-container">
              <LogoUpload />
              {handbooks?.length > 0 ? <div className="handbook-grid-title">
                <div className="left-side">
                  <h1 className="left-side-title">Your handbooks</h1>
                  <div>Total handbooks: {handbooks?.length}</div>
                  <HandbookCompletionDescription description={popupText} isPopup={false} />
                </div>
                <div className="right-side">
                  <div onClick={newHandbook} className="right-side-button">
                    <div>+</div>
                    <div>New Handbook</div>
                  </div>
                </div>
              </div>
                :
                <div className='no-handbook-container'>
                  <div className='no-handbook-wrapper'>
                    <div className='no-handbook-img'>
                      <img src="./images/no-handbook-image.svg" alt="no hanbook image" />
                    </div>
                    <div className='no-handbook-title'>You have no handbook</div>
                    <div className='no-handbook-text'>Start by creating new handbook</div>
                    <div onClick={newHandbook} className="no-create-new right-side-button">
                      <div>+</div>
                      <div>New Handbook</div>
                    </div>
                  </div>
                </div>
              }

              <div className="handbook-folder-list">
                {handbooks?.length > 0 && handbooks?.map((quizObj, i) => {
                  if ((data.currentPageNumb - 1) * 8 <= i && data.currentPageNumb * 8 > i) {
                    return (
                      <div className="handbook-folder" key={quizObj?.id + i}>
                        <div>
                          <div className="handbook-folder-section">
                            <h2>
                              {getInputValues('1', quizObj?.additionalDetails)?.value}
                            </h2>
                          </div>
                          <div className="handbook-folder-section">
                            <div>Workers</div>
                            <div>{getInputValues('2', quizObj?.additionalDetails)?.value}</div>
                          </div>
                          <div className="handbook-folder-section">
                            <div>Farming Operation</div>
                            <div>
                              {getInputValues('3', quizObj?.additionalDetails)?.value
                                ? 'Yes'
                                : 'No'}
                            </div>
                          </div>
                          <div className="handbook-folder-section">
                            <div>Completed Date</div>
                            <div>{(getInputValues('completedDate', quizObj?.additionalDetails) && getInputValues('completedDate', quizObj?.additionalDetails) > 0) ? formatDate(getInputValues('completedDate', quizObj?.additionalDetails)) : '-'}</div>
                          </div>
                          <div className="border-grey"></div>
                          <div className="handbook-folder-buttons">
                            <div className='download-handbook-profile' onClick={() => downloadHandbook(quizObj)} disabled={loading}>
                              <img src="./images/download-handbook-profile.svg" alt="download handbook" />
                            </div>
                            <div className='delete-icon' onClick={() => deleteHandbook(quizObj)}>
                              <DeleteOutlined />
                            </div>
                            <div className='edit-handbook-profile' onClick={() => editHandbook(quizObj)}>Edit</div>
                          </div>
                        </div>
                      </div>
                    );
                  }
                })}
              </div>
              <div className="handbook-pagination">
                {handbooks.length > 0 && <Pagination
                  defaultCurrent={data.currentPageNumb}
                  onChange={changedPageNumber}
                  pageSize={8}
                  total={handbooks.length}
                />}
              </div>
            </div>
          </div>
        }
        <div className="handbook-download-page">
          {renderQuizReview && <Quiz3Review renderQuizReview={renderQuizReview} downloadLinkRef={downloadRef} backPage={() => goBack()} nextPage={() => goNext()}></Quiz3Review>}
        </div>
      </AuthenticatedTemplate >

      <UnauthenticatedTemplate>
        <div className='not-auth-profile'>
          <div>
            Can only see profile page once logged in.
          </div>
          <Button className="quiz-auth-button quiz-auth-button-register" onClick={handleLoginRedirect}>
            {'Register an account'}
          </Button>
        </div>
      </UnauthenticatedTemplate>
    </>
  );
};
